import {
  Box,
  BoxProps,
  Flex,
  IconButton,
  IconButtonProps,
} from '@chakra-ui/react'

type NumberInputStepperOptions = { size?: 'sm' | 'md' }

export const NumberInputStepperGroup = ({
  size,
  ...props
}: BoxProps & NumberInputStepperOptions) => {
  const gap = size === 'sm' ? '0px' : '2px'

  return <Flex gap={gap} alignItems="center" {...props} />
}

export const NumberInputStepButton = ({
  size,
  ...props
}: IconButtonProps & NumberInputStepperOptions) => {
  const px = size === 'sm' ? '5px' : '10px'

  return (
    <IconButton
      px={px}
      py="10px"
      borderRadius="5px"
      color="presets.neutral.60"
      _dark={{ color: 'presets.neutral.60' }}
      {...props}
    />
  )
}

export const NumberInputStepperSeparator = () => (
  <Box
    height="16px"
    border="1px"
    borderLeft="1px solid"
    borderRight="0"
    borderColor="presets.neutral.30"
    _dark={{ borderColor: 'presets.neutral.90' }}
  />
)
